import { ImportHtmlComponent } from '../import-html/import-html.component';
import { SimpleConfirmDialogComponent } from '../../../../dialogs/simple-confirm-dialog/simple-confirm-dialog.component';
import { TranslocoService } from '@jsverse/transloco';
import { firstValueFrom, forkJoin, Observable, Subscription } from 'rxjs';
import { PackagingUnitNavigationService } from '../../../../../navigation/services/navigation-services/packaging-unit-navigation.service';
import { ActivatedRoute, Router, UrlTree } from '@angular/router';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ImportExportApiService } from 'src/app/data-transfer/services/import-export-api-service';
import { ChangeType, ImportParentComponent } from '../import-parent/import-parent.component';
import { ChangePackagingUnitCandidateDto } from 'src/app/data-transfer/entities/packaging-unit-entities/change-packaging-unit-candidate-dto';
import { SimpleDialogData } from 'src/app/components/dialogs/simple-alert-dialog/simple-alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { getDialogConfig } from 'src/app/util/dialog-util';
import { AnalysisApiService } from 'src/app/data-transfer/services/analysis-api-service';
import { DialogActions } from 'src/app/model/dictionary';
import { PackagingPart } from 'src/app/model/packaging-part-enum';
import { DirectoryApiService } from 'src/app/data-transfer/services/directory-api-service';
import { Location } from '@angular/common';
import { ImportCandidateDto } from 'src/app/data-transfer/entities/import-candidate-dto';
import { ChangeCandidateDto } from 'src/app/data-transfer/entities/change-candidate-dto';
import { FormControl } from '@angular/forms';
import { ComponentNavigationService } from 'src/app/navigation/services/navigation-services/component-navigation-service';
import { ComponentTypeService } from 'src/app/navigation/services/component-type-service';
import { MaterialNavigationService } from 'src/app/navigation/services/navigation-services/material-navigation.service';
import { PackagingSystemNavigationService } from 'src/app/navigation/services/navigation-services/packaging-system-navigation.service';
import {
  ArchiveActivatedText,
  ArhiveText,
  ChangeTrackingText, ComponentText,
  ImportText,
  ImportTypeText,
  MaterialText,
  NewDataSetsText,
  PackagingSystemText,
  PackagingTypeText,
  PackagingUnitText,
} from 'src/app/model/path-building-blocks';
import { ImportTypeSetting, PackagingImportHelper } from '../../../models/packaging-import-helper';
import { PackagingUnitImportHelper } from '../../../models/packaging-unit-import-helper';
import { PackagingComponentImportHelper } from '../../../models/packaging-component-import-helper';
import { PackagingMaterialImportHelper } from '../../../models/packaging-material-import-helper';
import { PackagingSystemImportHelper } from '../../../models/packaging-system-import-helper';
import { PathResolveService } from 'src/app/services/path-resolve.service';

@Component({
  selector: 'app-import-packaging',
  templateUrl: './import-packaging.component.html',
  styleUrls: ['./import-packaging.component.scss'],
})
export class ImportPackagingComponent extends ImportParentComponent implements OnInit, OnDestroy {
  @ViewChild('importHtml') importHtmlComponent!: ImportHtmlComponent;
  @ViewChild('changeHtml') changeHtmlComponent!: ImportHtmlComponent;

  selectedTabIndex = 0;
  packagingPartEnum = PackagingPart;
  packagingPartControl = new FormControl(PackagingPart.Unit, { nonNullable: true });
  archiveControl = new FormControl(false, { nonNullable: true })
  packagingPartImportHelper!: PackagingImportHelper;
  selectedTabsSeen:number[] = [];

  selectedCandidates: ImportCandidateDto[] = [];
  selectedChanges: ChangeCandidateDto[] = [];

  private packagingPartControlSubscribtion?: Subscription
  private archiveControlSubscribtion?: Subscription

  get selectedPackagingPart(): PackagingPart {
    return this.packagingPartControl.value;
  }

  get tableTitleImports(): string {
    return this.translateService.translate(this.packagingPartImportHelper.getTableTitle(ImportTypeSetting.Import, this.archiveActive));
  }

  get tableTitleChanges(): string {
    return this.translateService.translate(this.packagingPartImportHelper.getTableTitle(ImportTypeSetting.ChangeTracking, this.archiveActive));
  }

  get displayedColumns() {
    return this.packagingPartImportHelper.getDisplayedColumns();
  }

  constructor(
    protected dialog: MatDialog,
    protected translateService: TranslocoService,
    protected directoryApiService: DirectoryApiService,
    private importExportApiService: ImportExportApiService,
    private analysisApiService: AnalysisApiService,
    private packagingUnitNavigationService: PackagingUnitNavigationService,
    private componentNavigationService: ComponentNavigationService,
    private componentTypeService: ComponentTypeService,
    private materialNavigationService: MaterialNavigationService,
    private packagingSystemNavigationService: PackagingSystemNavigationService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {
    super(dialog, translateService, directoryApiService);
  }

  ngOnInit(): void {
    this.packagingPartControlSubscribtion = this.packagingPartControl.valueChanges.subscribe(_ => {
      this.selectedTabsSeen = [];
      this.changePackagingPart(_);
      this.loadAllDataSources();
    });
    this.archiveControlSubscribtion = this.archiveControl.valueChanges.subscribe(archiveFlag=> {
      this.changeArchiveType(archiveFlag);
    });


    this.route.paramMap.subscribe(params => {
      if (params.get(ImportTypeText) === ChangeTrackingText) {
        this.selectedTabIndex = 1;
      }

      if (params.get(ArchiveActivatedText) === ArhiveText) {
        this.archiveControl.setValue(true);
      }

      const packagingPart = params.get(PackagingTypeText);
      if (packagingPart === PackagingUnitText) {
        this.packagingPartControl.setValue(PackagingPart.Unit);
        return;
      }
      if (packagingPart === ComponentText) {
        this.packagingPartControl.setValue(PackagingPart.Component);
        return;
      }
      if (packagingPart === MaterialText) {
        this.packagingPartControl.setValue(PackagingPart.Material);
        return;
      }
      if (packagingPart === PackagingSystemText) {
        this.packagingPartControl.setValue(PackagingPart.System);
        return;
      }
      this.router.navigate([PathResolveService.getPackagingImportPath(true,true)]);
    });
  }

  override ngOnDestroy(): void {
    if (this.packagingPartControlSubscribtion) {
      this.packagingPartControlSubscribtion.unsubscribe();
    }
    if (this.archiveControlSubscribtion) {
      this.archiveControlSubscribtion.unsubscribe();
    }
    super.ngOnDestroy();
  }

  changeArchiveType(showArchive: boolean) {
    const archiveType = showArchive ? ArchiveActivatedText: NewDataSetsText;

    if(showArchive) {
      this.showArchive(this.importHtmlComponent);
    } else {
      this.showNewImports(this.importHtmlComponent);
    }
    this.selectedCandidates = [];
    const importType = this.selectedTabIndex === 0 ? ImportText : ChangeTrackingText;
    const packagingPart = this.getTextFromPart(this.packagingPartControl.getRawValue());
    const urlTree: UrlTree  = this.router.createUrlTree(['../../../', packagingPart, importType, archiveType], { relativeTo: this.route });
    this.location.replaceState(urlTree.toString());
  }

  changeImportType() {
    this.packagingPartControl.setValue(this.selectedPackagingPart, { emitEvent: false, onlySelf: true });
    this.changePackagingPart(this.selectedPackagingPart);
    this.tabSeen();
  }

  changePackagingPart(packagingPart: PackagingPart) {
    const importType = this.selectedTabIndex === 0 ? ImportText : ChangeTrackingText;
    const archiveType = this.archiveActive ? ArchiveActivatedText: NewDataSetsText;
    const packagingPartText = this.getTextFromPart(this.packagingPartControl.getRawValue());
    const urlTree: UrlTree = this.router.createUrlTree(['../../../', packagingPartText, importType, archiveType], { relativeTo: this.route });

    if (packagingPart === PackagingPart.Unit) {
      this.packagingPartImportHelper = new PackagingUnitImportHelper(this.importExportApiService, this.packagingUnitNavigationService);
    }
    else if (packagingPart === PackagingPart.Component) {
      this.packagingPartImportHelper = new PackagingComponentImportHelper(this.importExportApiService, this.componentNavigationService, this.componentTypeService);
    }
    else if (packagingPart === PackagingPart.Material) {
      this.packagingPartImportHelper = new PackagingMaterialImportHelper(this.importExportApiService, this.materialNavigationService);
    }
    else if (packagingPart === PackagingPart.System) {
      this.packagingPartImportHelper = new PackagingSystemImportHelper(this.importExportApiService, this.packagingSystemNavigationService);
    }
    else {
      return
    }

    this.location.replaceState(urlTree.toString());
  }

  private getTextFromPart (packagingPart: PackagingPart): string {
    switch(packagingPart) {
      case PackagingPart.System:
        return PackagingSystemText;
      case PackagingPart.Unit:
        return PackagingUnitText
      case PackagingPart.Component:
        return ComponentText
      case PackagingPart.Material:
        return MaterialText;
    }
  }

  private loadAllDataSources() {
    this.spinner.show();
    const observableImports = this.packagingPartImportHelper.getPackagingImportCandidates();
    const observableChanges = this.packagingPartImportHelper.getPackagingChangeCandidates();

    if (observableImports == null || observableChanges == null) {
      this.spinner.hide();
      return;
    }

    this.loadDataSourceSubscription = forkJoin([observableImports, observableChanges]).subscribe(result => {
      this.setImportDatasource(result[0],this.importHtmlComponent);
      this.selectedCandidates = [];
      this.dataSourceChanges.data = result[1];
      this.dataSourceChanges.data.sort(this.sortingForNotifications)
      this.changeHtmlComponent.setDataSource(this.dataSourceChanges);
      this.selectedChanges = [];
      this.spinner.hide();
      this.tabSeen();

    });
  }

  tabSeen() {
    if(!this.selectedTabsSeen.includes(this.selectedTabIndex)) {
      this.selectedTabsSeen.push(this.selectedTabIndex);
      switch(this.selectedTabIndex) {
        case 0:
          this.packagingPartImportHelper.packagingImportCandidatesSeen().then(result => {
            this.packagingPartImportHelper.packagingImportCandidatesCountUpdate();
          })
          break;
        case 1:
          this.packagingPartImportHelper.packagingChangeCandidatesSeen().then(result => {
            this.packagingPartImportHelper.packagingChangeCandidatesCountUpdate();
          })
          break;
      }
    }
  }

  navigateToCandidate(candidate: ImportCandidateDto) {
    this.packagingPartImportHelper.navigateToCandidate(candidate);
  }

  navigateToChange(candidate: ChangeCandidateDto, seePackagingBeforeChange: boolean) {
    this.packagingPartImportHelper.navigateToChange(candidate, seePackagingBeforeChange);
  }

  // ---------- Import ----------

  setSelectedImportCandidates(importCandidates: ImportCandidateDto[]) {
    this.selectedCandidates = importCandidates;
  }

  removeCandidates() {
    const deleteFunction = this.packagingPartImportHelper.getDeleteFunction(ImportTypeSetting.Import);
    super.removeCandidates(this.selectedCandidates, deleteFunction, this.importHtmlComponent);
  }

  async proceedWithImport() {
    await super.selectDirectory();
    if (this.selectedImportType == null || this.selectedCandidates.length < 1 || this.targetDirectory == null) {
      return;
    }
    this.spinner.show();

    let recPossibleForAll = true;
    let lcaPossibleForAll = true;

    if (this.selectedPackagingPart === PackagingPart.Unit || this.selectedPackagingPart === PackagingPart.System) {
      recPossibleForAll = await this.isRecyclabilityAnalysisPossibleForSelected(ImportTypeSetting.Import);
      if (recPossibleForAll) {
        lcaPossibleForAll = await this.isLcaPossibleForSelected(ImportTypeSetting.Import);
      }
    }

    if (recPossibleForAll && lcaPossibleForAll) {
      this.doImport();
    } else {
      const data: SimpleDialogData = {
        title: this.translateService.translate('common.text.warning'),
        messages: [this.translateService.translate('warnings.importIncompletePackagingUnit')],
        icon: 'warning',
      };
      const confirmDialogConfig = getDialogConfig(data, '350px');
      const dialogRef = this.dialog.open(SimpleConfirmDialogComponent, confirmDialogConfig);
      this.dialogSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result.event === DialogActions.CONFIRM) {
          this.doImport();
        } else {
          this.spinner.hide();
          return;
        }
      });
    }
  }

  private async doImport() {
    const importFunction = this.packagingPartImportHelper.getImportFunctionImportCandidate();
    await super.importItems(this.selectedCandidates, importFunction);
    this.loadAllDataSources();
  }

  // ---------- Changes ----------

  setSelectedImportChanges(changes: ChangePackagingUnitCandidateDto[]) {
    this.selectedChanges = changes;
  }

  removeChanges() {
    const deleteFunction = this.packagingPartImportHelper.getDeleteFunction(ImportTypeSetting.ChangeTracking);
    const idsToDelete: number[] = this.packagingPartImportHelper.getPackagingIdsFromChangeCandidates(this.selectedChanges);
    super.removeChanges(this.selectedChanges, deleteFunction, idsToDelete, this.changeHtmlComponent);
  }

  async proceedWithChange() {
    let targetDirectoryRequired = false;
    if ([ChangeType.WithTrackingNew, ChangeType.WithoutTracking].includes(this.selectedChangeType)) {
      targetDirectoryRequired = true;
      await super.selectDirectory();
    }
    if (this.selectedChangeType == null || this.selectedChanges.length < 1 || (this.targetDirectory == null && targetDirectoryRequired)) {
      return;
    }
    this.spinner.show();
    let recPossibleForAll = true;
    let lcaPossibleForAll = true;

    if (this.selectedPackagingPart === PackagingPart.Unit || this.selectedPackagingPart === PackagingPart.System) {
      recPossibleForAll = await this.isRecyclabilityAnalysisPossibleForSelected(ImportTypeSetting.ChangeTracking);
      if (recPossibleForAll) {
        lcaPossibleForAll = await this.isLcaPossibleForSelected(ImportTypeSetting.ChangeTracking);
      }
    }

    if (recPossibleForAll && lcaPossibleForAll) {
      this.doChange();
    } else {
      const data: SimpleDialogData = {
        title: this.translateService.translate('common.text.warning'),
        messages: [this.translateService.translate('warnings.importIncompletePackagingUnit')],
        icon: 'warning',
      };
      const confirmDialogConfig = getDialogConfig(data, '350px');
      const dialogRef = this.dialog.open(SimpleConfirmDialogComponent, confirmDialogConfig);
      this.dialogSubscription = dialogRef.afterClosed().subscribe(result => {
        if (result.event === DialogActions.CONFIRM) {
          this.doChange();
        } else {
          this.spinner.hide();
          return;
        }
      });
    }
  }

  private async doChange() {
    if (this.selectedChangeType === this.changeTypeEnum.WithTrackingOverwrite) {
      const changeFunction = this.packagingPartImportHelper.getChangeFunctionChangeCandidate();

      const idsToChange: number[] = this.packagingPartImportHelper.getPackagingIdsFromChangeCandidates(this.selectedChanges);
      await super.applyChangesExistingItems(idsToChange, changeFunction);
      this.selectedChanges = [];
    } else {
      const isWithTracking = this.selectedChangeType === this.changeTypeEnum.WithTrackingNew;
      const changeFunction = this.packagingPartImportHelper.getImportFunctionImportCandidate();

      const idsToChange: number[] = this.selectedChanges.map(x => x.importCandidateId);
      await super.applyChangesNewItems(idsToChange, isWithTracking, changeFunction);
      this.selectedChanges = [];
    }
    this.loadAllDataSources();
  }

  private async isRecyclabilityAnalysisPossibleForSelected(importType: ImportTypeSetting): Promise<boolean> {
    let observablesRec: Observable<boolean>[] = [];
    if (importType === ImportTypeSetting.Import) {
      observablesRec = this.selectedCandidates.map(candidate => this.analysisApiService.isRecyclabilityAnalysisPossibleImport(candidate.id, this.selectedPackagingPart));
    }
    if (importType === ImportTypeSetting.ChangeTracking) {
      observablesRec = this.selectedChanges.map(change => this.analysisApiService.isRecyclabilityAnalysisPossibleImport(change.importCandidateId, this.selectedPackagingPart));
    }

    let isRecPossible: boolean[] = [];
    if (observablesRec.length > 0) {
      isRecPossible = await firstValueFrom(forkJoin(observablesRec));
    }
    const recPossibleForAll = !isRecPossible.includes(false);
    return recPossibleForAll;
  }

  private async isLcaPossibleForSelected(importType: ImportTypeSetting): Promise<boolean> {
    let observablesLca: Observable<boolean>[] = [];
    if (importType === ImportTypeSetting.Import) {
      observablesLca = this.selectedCandidates.map(candidate => this.analysisApiService.isLifeCycleAnalysisPossibleImport(candidate.id, this.selectedPackagingPart));
    }
    if (importType === ImportTypeSetting.ChangeTracking) {
      observablesLca = this.selectedChanges.map(change => this.analysisApiService.isLifeCycleAnalysisPossibleImport(change.importCandidateId, this.selectedPackagingPart));
    }

    let isLcaPossible: boolean[] = [];
    if (observablesLca.length > 0) {
      isLcaPossible = await firstValueFrom(forkJoin(observablesLca));
    }
    const recPossibleForAll = !isLcaPossible.includes(false);
    return recPossibleForAll;
  }
}
